import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakPoints;

const Perks = styled.div`
  label: Perks;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 2.25rem 1.25rem 0.75rem;
  gap: 3.625rem 2.1875rem;

  @media (${widthSmall}) {
    gap: 3.5rem 5rem;
    margin: 2rem 7.75rem;
  }

  @media (${widthMedium}) {
    margin-top: 2.2rem;
    gap: 5rem;
  }
`;

export const Styled = { Perks };
